<template>
	<tr>
		<td class="px-1 align-middle">
			<!-- Icone indiquant le drag&drop -->
			<font-awesome-icon :icon="['fas', 'grip-vertical']"  />
		</td>

		<!-- Icone indiquant l'etat de la sélection pour le facteur -->
		 <!-- A non barré : mode auto | A barré : mode manuel | Coloré : non en accord avec sélection arborescence -->
		<td class="px-2 text-center align-middle">
			<!-- Icone fontawesome en plusieurs couches (/!\ l'ordre est important) -->
			<font-awesome-layers :id="$id('factorState')" :role="factor.AutoFilter ? '' : 'button'" v-on="factor.AutoFilter ? undefined : {click : () => { factorBlockFeature().SetAutoMode() }}" >
				<font-awesome-icon v-if="factor.AutoFilter" :icon="['fas', 'circle']" size="2x" class="text-gray" transform="grow-2" /> <!-- Fond indication 'bouton' désactivé -->
				<font-awesome-icon v-else icon="slash" size="2x" transform="shrink-6 left-2 flip-v" :class="factor.InWarning ? 'text-warning' : 'text-black'" /> <!-- Barre indication mode manuel-->
				<font-awesome-icon :icon="['far', 'circle']" size="2x" :class="[{'text-warning' : factor.InWarning}]" /> <!-- Cercle indicatif mode erreur -->
				<font-awesome-icon icon="a" size="1x" transform="right-8" /> <!-- Lettre pour 'Auto' -->
			</font-awesome-layers>
		</td>

		<!-- Infobulle d'information sur l'icône d'état de la selection -->
		<b-tooltip :target="$id('factorState')" noninteractive triggers="hover">
			{{ factor.AutoFilter ? $t('AutoMsg') : $t('ManualMsg') }} <!-- Mode automatique/manuel -->
			<br/>
			{{ factor.InWarning ? $t('InWarningMsg') : '' }} <!-- Les noeuds sélectionnés ne sont pas tous affectés à ce facteur. -->
		</b-tooltip>

		<td class="px-2 align-middle">
			<b-button-group size="sm" class="d-flex btn-gray-light rounded-pill border border-gray">
				<b-button @click="setFactorOperator('/')" :pressed="factor.Operator == '/'" pill variant="gray" class="periodMode px-2">/</b-button>
				<b-button @click="setFactorOperator('*')" :pressed="factor.Operator == '*'" pill variant="gray" class="periodMode px-2">*</b-button>
			</b-button-group>
		</td>

		<td class="px-0 text-center align-middle">
			{{ FactorLabel }}
		</td>

		<td class="align-middle">
			<!-- Bouton 3 petits points !! -->
			<b-icon @click="factorBlockFeature().StartSelection()" v-b-tooltip.noninteractive.hover :title="$t('NodesSelection')" role="button" icon="three-dots-vertical" scale="1.5" /> <!--EditFactorEvent-->
		</td>
		<td class="px-0 align-middle">
			<b-icon @click="removeFactor()" role="button" icon="x" scale="2" class="text-danger" />
		</td>

		<component :ref="$id('FactorBlock' + Feature)" v-bind:is="'FactorBlock' + Feature" :Factor.sync="factor" :Variant="Variant"
			:FactorLabel="FactorLabel" />
	</tr>
</template>

<script lang="ts">
	import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

	import Factor from '@/types/Config/Factor';

	/** Traductions */
	import locales from "./locales/FactorBlock.json";

	/** FactorBlock spécialisés par feature */
	import FactorBlockEvolution from "./FactorBlock/Evolution/FactorBlock.vue";
	import FactorBlockBenchmarking from "./FactorBlock/Benchmarking/FactorBlock.vue";
	import IFactorBlockFeature from '@/interfaces/Config/Factor/IFactorBlockFeature';
     
    /** Block de paramétrage de facteur */
    @Component({
        components: {
			// FactorSelectionNodes,
			FactorBlockEvolution,
			FactorBlockBenchmarking
        },
        i18n: { messages: locales }
    })
    export default class FactorBlock extends Vue {
		/** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "secondary"})
		public Variant!: string;

		/** Nom de la fonctionnalité où se trouve le DataBlock (gestion affichage diff.) */
        @Prop()
        public Feature!: string;

		/** 
		 * FactorBlock enfant spécialisé pour une feature analysis (Evolution, Benchmarking, ...).
		 * Cf sous-dossier FactorBlock.
		 */
		private factorBlockFeature(): IFactorBlockFeature {
			return (this.$refs[this.$id('FactorBlock' + this.Feature)] as unknown as IFactorBlockFeature);
		}

		/** Facteur chargé par le FactorBlock */
		@PropSync('Factor', { default: () => {} })
		public factor!: Factor;

		/** Nom du facteur sélectionné */
		@Prop()
		public FactorLabel!: string;

		/** Supprime le facteur de la liste des facteurs sélectionnés */
		private removeFactor() {
			this.$emit('RemoveFactorEvent');
		}

		/**
		 * Change l'opérateur du facteur sélectionné
		 * @param factorOperator nouvel opérateur pour le facteur
		 */
		private setFactorOperator(factorOperator: string) {
			// Change la valeur de l'opérateur
			this.factor.Operator = factorOperator;

			this.$emit('UpdateRatioEvent');
		}
    }
</script>

<style scoped>

</style>